export default {
	title: "Enterprise",
	subTitle: "Тариф для крупных предприятий и франшиз",
	description:
		"Оставь заявку, и мы свяжемся для обсуждения индивидуальных условий.",
	ctaButtonText: "Оставить заявку",
}
